/** @jsxImportSource @emotion/react */
import React, { useEffect, useMemo, useState } from 'react';
import logo from '../../assets/logo.svg';
import { css } from '@emotion/react';
import { commonStyles } from '../../styles/commonStyles';

import { Form, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setTokens, selectIsAuthenticated } from '../../store/slices/authSlice';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppDispatch } from '../../store/store';
import {
  useRequestPinMutation,
  useVerifyPinMutation,
} from '../../api/apiSlice';

const styles = {
  container: css({ maxWidth: 320, margin: '0 auto', paddingTop: '100px' }),
};

const LoginPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [requestPin] = useRequestPinMutation();
  const [verifyPinMutation] = useVerifyPinMutation();
  const tempToken = useMemo(
    () => new URLSearchParams(location.search).get('token'),
    [location.search],
  );
  const redirect = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const fromState = (location.state as { redirect?: string } | null)?.redirect;
    const fromQuery = params.get('redirect');
    const fromStorage = sessionStorage.getItem('postLoginRedirect');
    const candidate = fromState || fromQuery || fromStorage;
    if (candidate && candidate.startsWith('/')) {
      return candidate;
    }
    return '/';
  }, [location.search, location.state]);

  useEffect(() => {
    if (tempToken) {
      requestPin({ tempToken });
    }
  }, [requestPin, tempToken]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate(redirect || '/');
      sessionStorage.removeItem('postLoginRedirect');
    }
  }, [isAuthenticated, navigate, redirect]);

  const [step, setStep] = useState(1);
  const [pseudo, setPseudo] = useState('');
    // const [telegramId, setTelegramId] = useState('');
    // const [pseudo, setPseudo] = useState('');
    // const [tempToken, setTempToken] = useState('');
    // const navigate = useNavigate();
  
    // const handleCheckTelegram = async (e) => {
    const handleLogin = async (values: { pseudo: string }) => {
      try {
        const { pseudo } = values;
        await requestPin({ pseudo }).unwrap();
        setStep(2);
        setPseudo(pseudo);
      } catch (err: any) {
        // error toast handled globally
      }
    };
  
    const handleSendCode = async (values: { pin: string }) => {
    try {
      const { pin } = values;
      const data = await verifyPinMutation({ pseudo, pin }).unwrap();
      dispatch(setTokens(data));
        navigate(redirect || '/', { replace: true });
        sessionStorage.removeItem('postLoginRedirect');
    } catch (error: any) {
      // error toast handled globally
    }
      // e.preventDefault();
      // try {
      //   await api.post('/auth/register/create-pseudo', { pincode });
      //   navigate('/login');
      // } catch (err) {
      //   alert(err.response?.data?.message || 'Ошибка');
      // }
    };
  // const onFinish = async (values: { username: string; pincode: string }) => {
  //   try {
  //       // @ts-ignore
  //     const resultAction = await dispatch(login(values));
  //     if (login.fulfilled.match(resultAction)) {
  //       navigate('/');
  //     } else {
  //       message.error('Ошибка авторизации');
  //     }
  //   } catch (error: any) {
  //     message.error('Ошибка: ' + error.message);
  //   }
  // };

  return (
    <div css={styles.container}>
        
      <div css={commonStyles.textCenter}>
        <img src={logo} className="App-logo" alt="Canifole Logo" />
        v.0.0.2
    </div>
      {step === 1 && <Form name="login" layout="vertical" onFinish={handleLogin}>
        <Form.Item
          label="Логин"
          name="pseudo"
          rules={[{ required: true, message: 'Введите логин' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Войти
          </Button>
        </Form.Item>
      </Form>}
        {pseudo && <Form name="pin" layout="vertical" onFinish={handleSendCode}>
          <Form.Item
          label="Код подтверждения"
          name="pin"
          rules={[{ required: true, message: 'Введите пароль' }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Отправить код
          </Button>
        </Form.Item>
      </Form>}
    </div>
  );
};

export default LoginPage;
